<script setup lang="ts">
import type { NavigationMenuListProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

import { cn } from '@/utils';
import { NavigationMenuList, useForwardProps } from 'reka-ui';
import { computed } from 'vue';

const props = defineProps<
	NavigationMenuListProps & { class?: HTMLAttributes['class'] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);

const navigationMenuList = ref<typeof NavigationMenuList | null>(null);
</script>

<template>
	<NavigationMenuList
		ref="navigationMenuList"
		v-bind="forwardedProps"
		:class="
			cn(
				'group flex flex-1 list-none items-center justify-center gap-x-1',
				props.class
			)
		"
	>
		<slot />
	</NavigationMenuList>
</template>
